import {
  queryAddEditWebhookMapping,
  queryAddNewWebhookMapping,
  queryDeleteItem,
  queryEditItemWebhookMapping,
  queryList,
} from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'webhookMapping',
  state: {
    newWebhookMapping: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select:
      'id,sourceParameterCodification,sourceParameterPosition, sourceTableParameterName,sourceParameterName',
    notSelectSearch: 'sourceParameterCodification,sourceParameterPosition',
    expand: {
      destinationForm: { select: 'name' },
      destinationField: { select: 'displayText' },
      destinationVariable: { select: 'internalName' },
    },
    paramsView: {
      select:
        'id,valueDestination,sourceParameterCodification,sourceParameterPosition, sourceTableParameterName,sourceParameterName, formFieldValueDestination, destinationAttachmentFileName,destinationAttachmentContentType',
      expand: {
        destinationForm: { select: 'name' },
        destinationField: { select: 'displayText' },
        destinationVariable: { select: 'internalName' },
      },
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'queryWebhookMappings',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewWebhookMapping({ payload }, { put }) {
      yield put({
        type: 'addWebhookMapping',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewWebhookMapping',
          payload,
        });
      }
    },

    *editItemWebhookMapping({ payload }, { call, put }) {
      try {
        const table = yield call(queryEditItemWebhookMapping, payload);
        yield put({
          type: 'editWebhookMapping',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewWebhookMapping({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewWebhookMapping, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveWebhookMapping',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditWebhookMapping({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddEditWebhookMapping, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveWebhookMapping',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveWebhookMapping',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *showItemWebhookMapping({ view }, { put }) {
      yield put({
        type: 'showEditItemWebhookMapping',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryWebhookMappings(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addWebhookMapping(state, { payload }) {
      return {
        ...state,
        newWebhookMapping: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewWebhookMapping(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editWebhookMapping(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    saveWebhookMapping(state, { payload }) {
      return {
        ...state,
        saveWebhookMapping: payload,
        newWebhookMapping: false,
        selectedItem: false,
      };
    },

    showEditItemWebhookMapping(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newWebhookMapping: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
